import React, { useState, FC } from 'react';
import playButton from 'assets/img/playButton.png';
import { Box } from '@material-ui/core';
import clsx from 'clsx';
import EventStartTime from '../EventStartTime';
import { EventType } from '../../../../models/enums/EventType';
import { useStyles } from './styles';

interface Props {
    isMobile?: boolean;
    eventDate: string;
    startIn: string;
    purchased: boolean;
    isCreator: boolean;
    eventType: { code: EventType | null; name: string | null };
    upcoming: boolean;
    live: boolean;
    event_uuid: string;
    event_cover_image: string;
    event_presentation_video: string;
}

const PreviewBox: FC<Props> = ({
    isMobile,
    eventDate,
    startIn,
    purchased,
    isCreator,
    eventType,
    upcoming,
    live,
    event_uuid,
    event_cover_image,
    event_presentation_video,
}) => {
    const classes = useStyles({ isMobile });

    const [isPlayingVideo, setIsPlayingVideo] = useState<boolean>(
        event_presentation_video !== null &&
            event_presentation_video !== undefined &&
            event_presentation_video !== '',
    );

    const startVideoPlay = () => setIsPlayingVideo(true);
    const handleVideoPlayEnded = () => setIsPlayingVideo(false);

    return (
        <Box
            className={clsx(
                classes.container,
                (isMobile || isPlayingVideo) && classes.containerMobile,
                (isCreator || purchased) && classes.containerForCreator,
            )}
        >
            {isPlayingVideo ? (
                <video className={classes.video} controls={false} autoPlay onEnded={handleVideoPlayEnded}>
                    <source src="https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4" />
                </video>
            ) : (
                <Box className={classes.eventImageContainer}>
                    <EventStartTime
                        eventDate={eventDate}
                        upcoming={upcoming}
                        live={live}
                        purchased={purchased}
                        isCreator={isCreator}
                        startIn={startIn}
                        eventUUID={event_uuid}
                        eventType={eventType}
                    />

                    <img
                        className={clsx(classes.eventImage, !purchased || (!upcoming && classes.mt0))}
                        src={event_cover_image}
                        alt="event cover"
                    />

                    {event_presentation_video && (
                        <img
                            alt="play button"
                            onClick={startVideoPlay}
                            src={playButton}
                            className={classes.playButton}
                        />
                    )}
                </Box>
            )}
        </Box>
    );
};

export default PreviewBox;
